<div class="book-demo-container">
    <!-- <div class="header">
        <h2 class="heading">Book A <span>Demo</span></h2>
        <button mat-icon-button (click)="close()" class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div> -->

    <div class="title-underline"></div>
    <button mat-icon-button (click)="close()" class="close-btn">
        <mat-icon>close</mat-icon>
    </button>
    <p class="sub-text text-center">
        Fill in your details to schedule a demo session.
    </p>

    <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <!-- Name Field -->
        <div class="form-group">
            <input type="text" placeholder="Name" formControlName="name" class="formField" />
            <div class="alertV" *ngIf="formGroup.get('name')?.hasError('required') && formGroup.get('name')?.touched">
                Name is required
            </div>
            <div class="alertV" *ngIf="formGroup.get('name')?.hasError('minlength') && formGroup.get('name')?.touched">
                Name must be at least 3 characters
            </div>
        </div>

        <!-- Mobile Number Field -->
        <div class="mobileFieldContainer mb-3">
            <input type="text" value="+91" class="formField countryCode" readonly />
            <div class="w-100">
                <input type="tel" placeholder="Mobile Number" maxlength="10" formControlName="mobile"
                    class="formField" />
                <div class="alertV"
                    *ngIf="formGroup.get('mobile')?.hasError('required') && formGroup.get('mobile')?.touched">
                    Mobile Number is required
                </div>
                <div class="alertV"
                    *ngIf="formGroup.get('mobile')?.hasError('pattern') && formGroup.get('mobile')?.touched">
                    Enter a valid 10-digit mobile number
                </div>
            </div>
        </div>

        <!-- Email Field -->
        <div class="form-group">
            <input type="email" placeholder="Email Address" formControlName="email" class="formField" />
            <div class="alertV" *ngIf="formGroup.get('email')?.hasError('required') && formGroup.get('email')?.touched">
                Email is required
            </div>
            <div class="alertV" *ngIf="formGroup.get('email')?.hasError('email') && formGroup.get('email')?.touched">
                Invalid email format
            </div>
        </div>

        <!-- Interest Field -->
        <div class="form-group">
            <select formControlName="interest" class="formField select-field">
                <option value="" disabled selected>Select Interest</option>
                <option [value]="interest" *ngFor="let interest of interestList">
                    {{ interest }}
                </option>
            </select>
            <div class="alertV"
                *ngIf="formGroup.get('interest')?.hasError('required') && formGroup.get('interest')?.touched">
                Please select an interest
            </div>
        </div>

        <!-- Message Field -->
        <div class="form-group">
            <textarea class="comment" formControlName="message" rows="3" placeholder="Message (Optional)"></textarea>
        </div>

        <!-- Submit Button -->
        <div class="submitBtnContainer">
            <button type="submit" class="btnGlobal--primary" [disabled]="formGroup.invalid">
                BOOK NOW
            </button>
        </div>
    </form>
</div>